/*
export const someGetter = (state) => {
}
*/
export const getLiveChat = (state) => {
  return state.socket
}

export const getIsMiniGlobalbot = (state) => {
  return state.main.account.isMiniGlobalbot
}


export const getExpandedTags = (state) => {
  return state.main.expandedTags
}

export const getKanbanBoardById = (state) => (id) => {
  return state.main?.kanban?.boards?.find(board => board._id === id) ?? null
}

export const getKanbanColumnsByBoardId = (state) => (boardId) => {
  const board = state.main.kanban?.boards?.find(board => board._id === boardId) ?? null

  const columns = state.main.kanban?.columns?.[boardId] ?? []

  if (!board || !board.columns || board.columns.length === 0) {
    return columns
  }

  const orderedColumns = []

  board.columns.forEach(columnId => {
    const column = columns.find(col => col._id === columnId)
    if (column) {
      orderedColumns.push(column)
    }
  })

  return orderedColumns
}

export const getKanbanCardsByColumnId = (state) => (columnId) => {
  return state.main.kanban.cards[columnId]
}

export const getKanbanBoards = (state) => {
  return state.main?.kanban?.boards ?? []
}

export const getKanbanBoardsFiltered = (state) => (botId, departmentsIds) => {
  return state.main?.kanban?.boards?.filter(board => board.chatbots.includes(botId) &&
    (board.departments.length === 0 ||
      board.departments.some(departmentId => departmentsIds.includes(departmentId)))) ?? []
}
export const getDefaultButtonColorNeutral = (state) => {
  return state.main.dark ? 'accent' : 'white'
}

export const getDefaultTextColor = (state) => {
  return state.main.dark ? 'white' : 'tertiary'
}

// Restrição de visualização por chatbots vinculados ao usuário.
// state.main.bots já vem filtrado aos chatbots permitidos quando restrictToLinkedBots
// está ativo (filtro central no login), então derivamos tokens/departamentos dele.
export const getIsRestrictedToLinkedBots = (state) => {
  return !!state.main.user?.restrictToLinkedBots
}

export const getAllowedBotTokens = (state) => {
  return (state.main.bots || []).map(bot => bot.tk).filter(Boolean)
}

export const genaiCredits = (state) => {
  return state.credits && typeof state.credits === 'object' ? state.credits : {}
}

export const hasGenaiCredits = (state) => {
  const c = state.credits && typeof state.credits === 'object' ? state.credits : {}

  const hasGenai = 'genai' in c
  const hasFranchise = 'genaiFranchise' in c

  const genai = Number(c.genai)
  const franchise = Number(c.genaiFranchise)

  const hasNoCredits =
    hasGenai && hasFranchise ? franchise <= 0 && genai <= 0 :
    hasFranchise ? franchise <= 0 :
    hasGenai ? genai <= 0 : true

  return !hasNoCredits
}

// Supermaster = funcionário Globalbot com permissão Master (10). Só ele opera o console de descadastros e envia e-mail sem grupo de desinscrição.
export const isSupermaster = (state) => {
  const user = (state.main ? state.main.user : state.user) || {}
  return Number(user.permission) === 10 && user.isEmployee === true
}

export const getUserInfo = (state) => {
  const user = (state.main ? state.main.user : state.user) || {}
  return {
    id: user._id,
    name: user.name,
    email: user.email,
    permission: user.permission,
    isEmployee: user.isEmployee,
    isMiniGlobalbot: user.isMiniGlobalbot,
    isSupermaster: isSupermaster(state)
  }
}
